<template>
  <Combobox
    v-model="selectedData"
    :title="$t('referenceBooks.devices.Device')"
    :keyName="'deviceId'"
    :item-text="'deviceName'"
    :item-value="'deviceId'"
    :disabled="mode === 1"
    :needCheck="needCheck"
    :items="items"
    v-on:change="onChange"
  />
</template>

<script>
import Combobox from '@/components/CommonComponents/RequiredComboboxField';

export default {
  components: {
    Combobox,
  },
  model: {
    prop: 'value',
    event: 'valueEv',
  },
  props: {
    value: {
      type: Number,
      default: 0,
    },
    needCheck: {
      type: Boolean,
      default: false,
    },
    items: {
      Type: Array,
      default: null,
    },
    mode: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      selectedData: null,
    };
  },
  watch: {
    value() {
      this.selectedData = this.value;
    },
  },
  methods: {
    onChange() {
      this.$emit('valueEv', this.selectedData);
    },
  },
};
</script>
